import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Currency, Locale } from '@/types/common';
import { storageKey } from './storageKeys';

interface PreferenceState {
  /** 사용자가 고른 언어. 첫 방문은 initI18n에서 명시적 URL 언어 또는 영어로 시작한다. */
  locale?: Locale;
  currency: Currency;
  setLocale: (locale: Locale) => void;
  setCurrency: (currency: Currency) => void;
}

export const defaultCurrencyFor = (locale: Locale): Currency =>
  locale === 'zh-CN' ? 'CNY' : 'USD';

export const usePreferenceStore = create<PreferenceState>()(
  persist(
    (set) => ({
      locale: undefined,
      currency: 'USD',
      setLocale: (locale) => set({ locale }),
      setCurrency: (currency) => set({ currency }),
    }),
    { name: storageKey.PREFERENCE_STORE },
  ),
);
